import React, { FC, ReactNode } from "react";

import cn from "classnames";

import PinLegendClassificationType from "@mapmycustomers/shared/enum/pinLegends/PinLegendClassificationType";

import styles from "./Button.module.scss";

export interface ButtonProps {
  active?: boolean;
  icon?: ReactNode;
  onClick?: (type: PinLegendClassificationType) => void;
  title: ReactNode;
  type: PinLegendClassificationType;
}

const Button: FC<ButtonProps> = ({ active, icon, onClick, title, type }) => {
  return (
    <div
      className={cn(styles.container, { [styles.active]: active })}
      onClick={() => onClick?.(type)}
    >
      {icon}
      <span>{title}</span>
    </div>
  );
};

export default Button;
